import { TabuDoc } from "@my-dld/screens/TabuRequest/BaseTabuRequestForm";
import { StringUtil } from "@eres/core";
import { formatAppDate } from "./Utils";
import { TabuProcedures } from "@10x/tabu-mobile-api";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { TabuPropertyType } from "./PropertyUtils";

export enum TabuDocTypes {
	IMAGE = 1,
	PDF = 2,
}

export function getTabuDocType( tabuDoc: TabuDoc ) {
	let type = TabuDocTypes.PDF;
	let fileUrl = tabuDoc.fileUrl;
	let localData = tabuDoc.localData;
	if ( fileUrl && !StringUtil.isEmptyStringOrNull( fileUrl ) ) {
		fileUrl = fileUrl.toLocaleLowerCase();
		if ( fileUrl.endsWith( ".png" ) || fileUrl.endsWith( ".jpg" ) )
			type = TabuDocTypes.IMAGE;
	} else if ( localData && !StringUtil.isEmptyStringOrNull( localData ) ) {
		const d = localData.split( ";" )[ 0 ];
		if ( d.includes( "image" ) )
			type = TabuDocTypes.IMAGE;
	}
	return type;
}

export function getTabuDocName( tabuDoc: TabuDoc ) {
	let fileUrl = tabuDoc.fileUrl;
	if ( fileUrl && !StringUtil.isEmptyStringOrNull( fileUrl ) )
		return fileUrl.substring( fileUrl.lastIndexOf( "/" ) + 1, fileUrl.length );
	return tabuDoc.fileName;
}

export function getTabuDocSize( tabuDoc: TabuDoc ) {
	let size = tabuDoc.fileSize;
	if ( size && size > 0 ) {
		return parseFloat( "" + ( size / ( 1024 * 1024 ) ) ).toFixed( 2 );
	}
	return "";
}

export function getTabuDocDate( tabuDoc: TabuDoc ) {
	let localData = tabuDoc.localData;
	if ( localData && !StringUtil.isEmptyStringOrNull( localData ) ) {
		return formatAppDate( new Date(), "en" );
	}
	return "";
}

const {
	ET, PV, IPV, SitePlan, PropertyDetailCertService, TWICService,
	LC, BCSReClassification, PropertyCutOff, OwnershipChange, DelayedPropertyCutOff, PropertyAnnex, DelayedPropertyAnnex
} = TabuProcedures;
export const PropertyServices = [ ET, PV, IPV, SitePlan, PropertyDetailCertService, OwnershipChange, BCSReClassification ];
export const MyRequestServices = [ LC, TWICService, PropertyDetailCertService, PV, IPV, SitePlan, OwnershipChange,
	PropertyCutOff, DelayedPropertyCutOff, BCSReClassification, PropertyAnnex, DelayedPropertyAnnex ];

export function canDoAnnex( tabuProperty: AssetCard ) {
	let canAnnex = false;
	switch ( tabuProperty.propertyTypeId ) {
		case TabuPropertyType.LAND:
			canAnnex = true;
			break;
		case TabuPropertyType.BUILDING:
		case TabuPropertyType.VILLA:
			if ( tabuProperty.isVilla ) {
				canAnnex = true;
			}
			break;
		default:
	}
	return canAnnex;
}
